import React from 'react';
import styled from 'styled-components';
import Loader from '@rsos/components/capstone/Loader';
import { Box } from '@rsos/components/capstone/base';
import { ModalBody } from '../../../base/Modal/ModalComponents';

const ModalLoading = () => {
  return (
    <ModalBody justify="center">
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    </ModalBody>
  );
};

export default ModalLoading;

const LoaderContainer = styled(Box).attrs({
  align: 'center',
  justify: 'center',
  mt: 20,
})``;
